// The mail links of today's landing page (v1, LandingPage.js). The new
// design (PublicV2) does not use them: its demo contact comes from
// config/contact.js.
export const DEMO_HREF = 'mailto:hello@solutionsandguidance.com?subject=IronSight%20demo%20request';
export const CONTACT_HREF = 'mailto:hello@solutionsandguidance.com?subject=IronSight%20enquiry';
